import React from 'react';
import PropTypes from 'prop-types';
import InputNumber from "../../../../../components/Application/ApplicationTable/InputNumber";

const Column = props => {
  return (
    <div className="d-flex flex-row flex-nowrap align-items-center justify-content-between py-2 px-3">
      <span>{props.content}</span>

      {(!props.isLast && props.listId === 'active') && <div style={{width: '50px'}}>
        <InputNumber
          className="text-right"
          autoFocus={false}
          onChange={props.onChangeWidth}
          value={props.width ?? null}
        />
      </div>}
    </div>
  );
};

Column.propTypes = {
  onChangeWidth: PropTypes.func.isRequired,
  isLast: PropTypes.bool.isRequired,
  listId: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  width: PropTypes.number,
};

export default Column;
